import { useEffect } from 'react'

const useEvent = (event: any, handler: () => void, passive = false) => {
  const hasWindow = typeof window !== 'undefined'

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener(event, handler, passive)

      return () => window.removeEventListener(event, handler)
    }
  }, [event, handler, hasWindow, passive])
}

export default useEvent
